/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import VuexPersistence from 'vuex-persist'

// Modules
import app from './modules/app'
import account from './modules/account'
import auth from './modules/auth'
import locale from './modules/locale'

Vue.use(Vuex)

export const VUEX_STORAGE_KEY = 'tuango_dashboard_tab_data'

const debug = process.env.NODE_ENV !== 'production'

const vuexLocal = new VuexPersistence({
  key: VUEX_STORAGE_KEY,
  storage: window.localStorage
})

const store = new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    account,
    app,
    auth,
    locale
  },

  /**
   * If strict mode should be enabled.
   */
  strict: debug,

  /**
   * Plugins used in the store.
   */
  plugins: debug ? [vuexLocal.plugin, createLogger()] : [vuexLocal.plugin]
})

store.dispatch('auth/observe')

export default store



// WEBPACK FOOTER //
// ./src/app/store/index.js